import { api } from "./api";

// MT-017 — ABM de usuarios de Backoffice.

export type BoRole = "SUPER_ADMIN" | "TENANT_ADMIN";

export interface BoUser {
  userId: number;
  email: string;
  firstName: string;
  lastName: string;
  tenantId: string;
  role: BoRole;
  active: boolean;
  cognitoId: string | null;
  hasMobileProfile: boolean;
}

export interface CreateBoUserPayload {
  email: string;
  first_name: string;
  last_name: string;
  role: BoRole;
  tenant_id?: string;
}

export const boUsersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBoUsers: build.query<BoUser[], void>({
      query: () => "/admin/bo-users",
      providesTags: ["boUsers"],
    }),
    createBoUser: build.mutation<
      { userId: number; email: string; role: BoRole; tenantId: string },
      CreateBoUserPayload
    >({
      query: (body) => ({ url: "/admin/bo-users", method: "POST", body }),
      invalidatesTags: ["boUsers"],
    }),
    updateBoUserRole: build.mutation<
      void,
      { userId: number; role: BoRole; tenantId?: string }
    >({
      query: ({ userId, role, tenantId }) => ({
        url: `/admin/bo-users/${userId}/role`,
        method: "PUT",
        // tenant_id: requerido al degradar a TENANT_ADMIN (el rol por-tenant necesita
        // un tenant destino); ignorado al promover a SUPER_ADMIN (rol global).
        body: { role, ...(tenantId ? { tenant_id: tenantId } : {}) },
      }),
      invalidatesTags: ["boUsers"],
    }),
    deactivateBoUser: build.mutation<void, { userId: number }>({
      query: ({ userId }) => ({ url: `/admin/bo-users/${userId}`, method: "DELETE" }),
      invalidatesTags: ["boUsers"],
    }),
  }),
});

export const {
  useGetBoUsersQuery,
  useCreateBoUserMutation,
  useUpdateBoUserRoleMutation,
  useDeactivateBoUserMutation,
} = boUsersApi;
